<template>
  <div class="bg-wrap-color">
      <PageBar>
        <div class="bg-color mb10 pt20 pb20"  :style="{width: '100%'}">
            <span class="mr20" style="font-size: 14px;font-weight: 600;cursor: pointer;" @click="handleClick" v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '列表(任务详情-返回)' }"><i class="el-icon-back ml20"></i>返回</span>任务ID： {{pageParams.id}}
        </div>
      </PageBar>
     
      <div style="height: 70px;"></div>
      <div class="pl20 pr20 pt10 pb10 bg-color mb10" >
          <p class="text-bold">目标账户与产品：</p>
          <p>
              <span class="text-bold"> 账户：</span> {{account_info.account_name}}（ID：{{account_info.account_id}}）；
              <span class="text-bold"> 产品：</span> {{app_info.map(item=>item.app_name+'('+item.app_id+')').join('、')}}
          </p>
      </div>

      <jt-table :data="[gather, ...tableData]"
      style="width: 100%;margin-top: 10px;"
      stripe
      :header-cell-style="{background:'#e8eaec',color:'#333'}"
      :row-class-name="tableRowClassName"
      size="mini"
      row-key="id"
      class="create_vivo_list"
      v-loading="loading"
	  :affixConfig="{ offset:  { top: 110, bottom: 0 }}"
      tooltip-effect="dark">
          <el-table-column label="状态" width="150">
              <template slot-scope="scope">
                  <div v-if="scope.$index==0">
                      <p><span class="text-bold">总计</span>(成功/失败)</p>
                      <!-- <p>{{gather.ad_total}}({{gather.ad_num}} / {{gather.ad_err_num}})</p> -->
                  </div>
                  <!-- 1-创建中，2-成功，3-计划失败，4-广告组失败，5-广告失败  -->
                  <p v-else-if="scope.row.detail_info.status == 1" class="text-color-info">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                  <p v-else-if="scope.row.detail_info.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                  <p v-else class="text-color-error"><el-tooltip class="item" effect="dark" :content="scope.row.detail_info.err_msg" placement="top"><span class="pointer">{{ scope.row.status_text}}<i class="el-icon-warning-outline"></i></span></el-tooltip></p>
              </template>
          </el-table-column>
		  <el-table-column label="序号" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{ ((pageNum - 1) * pageSize) + scope.$index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="产品信息" min-width="200"  show-overflow-tooltip prop="apps">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index==0">-</span>
                        <template v-else>
                            <p >{{row.apps.product_name||'-'}}</p>
                            <p>ID: {{  row.apps.promotion_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="版位" min-width="200"  show-overflow-tooltip prop="creative_size_name">
                <template slot-scope="{ row , $index}">
                    <span v-if="$index==0">-</span>
                        <template v-else>
                            <p >{{row.creative_size_name||'-'}}</p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="计划信息" min-width="200"  prop="campaign_info">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index==0">{{gather.plan_num}} / {{gather.plan_err_num}}</span>
                        <template v-else>
                            <p>计划状态：{{  row.campaign_info.plan_status_text}}</p>
                            <!-- <p>{{row.campaign_info.store_name||'-'}}</p> -->
                            <p>计划ID: {{  row.campaign_info.campaign_id }} </p>
                            <p>计划名称: {{  row.campaign_info.campaign_name }} </p>
                            <p>推广产品: {{  row.campaign_info.product_type_text }} </p>
                            <p>当日预算: {{  row.campaign_info.daily_budget }} </p>
                            <p>计划类型: {{  row.campaign_info.campaign_type_text }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="任务信息"  min-width="300">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">{{gather.adgroup_num}} / {{gather.adgroup_err_num}}</span>
                        <div v-else>
                            <p>任务状态：{{scope.row.adgroup_info.adgroup_status_text}}</p>
                            <p>任务名称：{{scope.row.adgroup_info.adgroup_name}}</p>
                            <p>任务ID：{{scope.row.adgroup_info.adgroup_id}}</p>
                            <p>智能分包渠道号：{{scope.row.adgroup_info.channel_pkg_number}}</p>
                            <el-tooltip class="item" effect="dark"  placement="top">
                                <div slot="content" style="max-height:500px; overflow:auto">
                                    <!-- <p>定向包ID：{{scope.row.adgroup_info.targeting_package_id}}</p> -->
                                    <p>定向包类型：{{scope.row.adgroup_info.targeting_package_scope_text}}</p>
                                    <p>投放开始日期：{{scope.row.adgroup_info.adgroup_begin_date}}</p>
                                    <p>投放结束日期：{{scope.row.adgroup_info.adgroup_end_date}}</p>
                                    <p>时间段类型 ：{{scope.row.adgroup_info.time_period_type_text}}</p>
                                    <p>时间段：{{scope.row.adgroup_info.time_period_text}}</p>
                                    <p>出价方式：{{scope.row.adgroup_info.price_type_text}}</p>
                                    <p>出价：{{scope.row.adgroup_info.price}}</p>
                                    <p>期望转化成本：{{scope.row.adgroup_info.conversion_cost}}</p>
                                    <p>ROI系数：{{scope.row.adgroup_info.roi_ratio}}</p>
                                    <p>版位ID：{{scope.row.creative_size_id}}</p>
                                    <p>版位：{{scope.row.creative_size_name}}</p>
                                    <p>智能提价标志：{{scope.row.adgroup_info.dyn_price_flag_text}}</p>
                                    <p>智能提价上限：{{scope.row.adgroup_info.dyn_price_upper_limit}}</p>
                                    <!-- <p>转化跟踪指标ID：{{scope.row.adgroup_info.tracking_id}}</p>
                                    <p>转化跟踪指标：{{scope.row.adgroup_info.tracking_id_text}}</p> -->
                                    <p>投放策略id：{{scope.row.adgroup_info.ocpc_strategy}}</p>
                                    <p>投放策略：{{scope.row.adgroup_info.ocpc_strategy_text}}</p>
                                    <p>深度优化类型：{{scope.row.adgroup_info.deep_optimize_type_text}}</p>
                                    <p>深度转化目标：{{scope.row.adgroup_info.deep_effect_target_text}}</p>
                                    <p>深度转化价格：{{scope.row.adgroup_info.deep_effect_price}}</p>
                                    <p>推广目的：{{scope.row.adgroup_info.objective_type_text}}</p>
                                    <p>多日频控N天M次中的N：{{scope.row.adgroup_info.fc_days}}</p>
                                    <p>多日频控N天M次中的M：{{scope.row.adgroup_info.fc_upper_times}}</p>
                                    <!-- <p>关键词：{{scope.row.adgroup_info.keywords}}</p> -->
                                </div>
                                <el-button type="text">更多</el-button>
                            </el-tooltip>
                            
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="创意名称" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{scope.row.creative_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="动态词包标识" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{scope.row.dyn_ad_text_flag}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创意模式" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{scope.row.creative_mode}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创意详情" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <div v-else>
                            <p>创意状态：{{scope.row.ad_status_text}}</p>
                            <p>文案：{{scope.row.title}}</p>
                            <p>描述：{{scope.row.description}}</p>
                            <p>品牌名称：{{scope.row.corporate}}</p>
                            <el-tooltip class="item" effect="dark"  placement="top">
                                <div slot="content" style="max-height:500px; overflow:auto">
                                    <p>落地页信息</p>
                                    <p>落地页类型：{{scope.row.landing_page_type_text}}</p>
                                    <p>落地页地址：{{scope.row.landing_page}}</p>
                                    <p>应用直达地址信息：{{scope.row.deeplink}}</p>
                                    <p>展示监控地址：{{scope.row.impression_monitor_url}}</p>
                                    <p>点击监控地址：{{scope.row.click_monitor_url}}</p>
                                    <p>按钮文案：{{scope.row.selected_text_id_text}}</p>
                                    <p>行业分类ID：{{scope.row.industry_id}}</p>
                                    <p>行业标签：{{scope.row.industry_labels}}</p>
                                    <p>创意模板ID：{{scope.row.template}}</p>
                                    <p>开屏提示文案</p>
                                    <p>摇一摇交互提示文案：{{scope.row.wave_txt}}</p>
                                    <p>滑动交互提示文案：{{scope.row.swipe_txt}}</p>
                                    <p>摇一摇加点击交互提示文案：{{scope.row.wave_clk_txt}}</p>
                                    <p>滑动加点击交互提示文案：{{scope.row.swipe_clk_txt}}</p>
                                    <p>开屏跳转提示文案：{{scope.row.redirect_txt}}</p>
                                    <p>服务卡片ID：{{scope.row.service_card_id}}</p>
                                    <p>优先跳转链接：{{scope.row.jump_priority}}</p>
                                </div>
                                <el-button type="text">更多</el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
		  <!-- <el-table-column label="商品库" min-width="200"  show-overflow-tooltip prop="store_info">
              <template slot-scope="{ row , $index}">
                  <span v-if="$index==0">-</span>
                  <template v-else>
					<p >{{row.store_info.store_name||'-'}}</p>
				  	<p>ID: {{  row.store_info.store_id }} </p>
				  </template>
              </template>
          </el-table-column> -->
		
		  <el-table-column label="转化跟踪" min-width="200"  show-overflow-tooltip prop="effect_tracking">
              <template slot-scope="{ row , $index}">
                  <span v-if="$index==0">-</span>
                  <template v-else>
					<p >{{row.effect_tracking.effect_name||'-'}}</p>
				  	<p>ID: {{  row.effect_tracking.tracking_id }} </p>
				  </template>
              </template>
          </el-table-column>
		  <el-table-column label="定向包" min-width="200"  show-overflow-tooltip prop="targeting_package">
              <template slot-scope="{ row , $index}">
                  <span v-if="$index==0">-</span>
                  <template v-else>
					<p >{{row.targeting_package.targeting_name||'-'}}</p>
				  	<p>ID: {{  row.targeting_package.targeting_id }} </p>
				  </template>
              </template>
          </el-table-column>
          <el-table-column label="智能分包" min-width="200"  show-overflow-tooltip prop="channel">
              <template slot-scope="{ row , $index}">
                  <span v-if="$index==0">-</span>
                  <template v-else>
					<p >{{row.channel.channel_pkg_name||'-'}}</p>
				  	<p>渠道号: {{  row.channel.channel_pkg_number }} </p>
				  </template>
              </template>
          </el-table-column>
		  <el-table-column label="创意" min-width="300"  prop="material_list">
              <template slot-scope="{ row , $index}">
                  <span v-if="$index==0">{{gather.ad_num}} / {{gather.ad_err_num}}</span>
                  <template v-else>
					<IdeaColumnTemp  :list="Array.from({ length: row.material_list.length> 3 ? 3 :row.material_list.length }).map((_,i)=>row.material_list[i])"/>
                    <el-button type="text"  v-if="row.material_list.length> 3" @click="openPreviewMaterialModal(row.material_list)">点击查看更多</el-button>
                    <!-- previewMaterialModal -->
				  </template>
              </template>
          </el-table-column>


      </jt-table>

      <div class="bg-color tar p20">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
      </div>

  </div>
</template>

<script>
import { getTaskDetailApi, getTaskDetailTotalApi } from '@/api'
import IdeaColumnTemp from './components/ideaColumnTemp';
import PageBar from '@/components/PageBar'
import { previewMaterialModal } from './modal/index'
export default {
  name: "infopage",
  components: {
      IdeaColumnTemp, PageBar
  },
  props:{
	pageParams: {
		type: Object,
		default: () => {
			return {};
		},
	},
	platId: {
		type: Number,
		default: 10
	}
  },
  data() {
      return {
          gather: {               //数据汇总
              plan_num:'',
              plan_total:'',
              adgroup_num:'',
              agroup_total:'',
              ad_num:'',
              ad_total:'',
          },
          params:{},  //创意详情
          loading: false,  // 表格loading
          pageNum: 1,
          pageSize: 10,
          total: 10,
          tableData: [],
          account_info:{
              account_id:'',
              account_name:'',
          },
          app_info:[],
          queryParams:{},
      }
  },
  computed:{
  },
  watch:{
    
  },
  mounted() {
     this.getPageAllData();
  },
  methods: {
        openPreviewMaterialModal(list) {
            previewMaterialModal({ 
                props: { list },
             })
        },
      // 每页条数
      handleSizeChange(val) {
          this.pageSize = val
          this.pageNum = 1
          this.getList()
      },
      // 当前页数
      handleCurrentChange(val) {
          this.pageNum = val
          this.getList()
      },
      handleClick() {
          this.$emit("to-page", "ListPage")
      },
	//   获取所有信息
	  async getPageAllData(){
		const params = {
			task_id: this.pageParams.id,
			plat_id: this.platId,
		};
		const { data } = await getTaskDetailTotalApi(params)
		const { account_info, app_info, total_info  } = data;
        
		this.app_info = app_info;
		this.account_info = account_info[0];
		this.gather = total_info[0];
		this.getList()
	  },
      async getList() {
		try {
			this.loading = true;
			const params = {
				plat_id: this.platId,
				task_id: this.pageParams.id,
				pn: this.pageNum,
				rn: this.pageSize,
			}
			const { data } = await getTaskDetailApi(params);
            this.total = data.totalCnt;
			this.tableData = data.list || [];
		} catch (error) {
			this.$message.error(error.info || '获取失败');
		}finally{
			this.loading = false;
		}
	  },
      tableRowClassName({row, rowIndex}){
          if (rowIndex === 0) {
              return 'gray-row';
          }
          return '';
      },
  },
  beforeDestroy() {
  },
  destroyed() {
     
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep.el-table .gray-row{
      background-color: #f4f4f4;
  }

.ellipsis{
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline;
}
.ellipsis-row-2{
  width: 100%;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.create_vivo_list tbody .cell div{
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline;
}

.bg-wrap-color{
  background-color:#F1F4F9;
}
.bg-color{
  background-color:#FFF;
}

</style>
